<template>
  <div>
    <header-applis titre="Personnaliser l’offre à votre profil" sous-titre="Avant de m’engager dans une formation, j’ai besoin de connaitre" index-progression-courante="3"/>
    <div class="wrapper__content">
      <div v-for="(valeur, index) in valeursPossibles" :key="index" class="checkbox-wrapper">
        <input type="checkbox" :id="'choix_' + index" :value="valeur" v-model="informationsComplementaires" name="statut">
        <label :for="'choix_' + index">{{ valeur }}</label>
      </div>
    </div>
    <footer-applis ecran-precedent="preferencesformations" :ecran-suivant="ecranSuivant()" label-suivant="Je confirme et je passe à la suite"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';

export default {
  name: 'preferencesengagementformation',
  components: {
    FooterApplis,
    HeaderApplis
  },
  data() {
    return {
      informationsComplementaires: [],
      valeursPossibles: [
        'Le temps de travail personnel à investir',
        'Son rythme',
        'Son adéquation avec ma vie personnelle',
        'Le lieu de la formation et la mobilité attendue',
        'Les conditions physiques exigées (d’accès et de mobilité)',
        'L’équipement matériel nécessaire',
        'La maîtrise attendue des outils bureautiques / informatiques',
        'La compatibilité avec mes activités professionnelles',
        'Son coût et son financement'
      ]
    }
  },
  computed: {
    /**
     * Récupération des informations de parcours.
     * @returns {Object} Les informations de parcours.
     */
    informationsParcours() {
      return this.$store.getters.getInformationsParcours;
    }
  },
  methods: {
    /**
     * Méthode de passage à l'écran suivant. Permet de faire les vérifications de saisie.
     */
    ecranSuivant() {
      if (!this.informationsComplementaires || this.informationsComplementaires.length === 0) {
        return '';
      }
      this.$store.commit('setInformationsComplementaires', this.informationsComplementaires);
      return 'choixstatutfinancement';
    }
  },
  created() {
    this.informationsComplementaires = this.informationsParcours.informationsComplementaires;
  }
}
</script>
